import {TriangleElements}				from "../../graphics/TriangleElements";

export class ParticleData
{
	public particleIndex:number /*uint*/;
	public numVertices:number /*uint*/;
	public startVertexIndex:number /*uint*/;
	public elements:TriangleElements;
}

export default ParticleData